import { InvokeCommand, LambdaClient } from "@aws-sdk/client-lambda";

import {
  UserMapShareLink,
  WithUserId,
} from "../../../../src/auth/domain/model/User.js";
export * from "../../../../src/auth/domain/model/User.js";

import { AUTHORIZER_LAMBDA_FUNCTION_NAME } from "../authorizer/model.js";

export interface TrackingCredentialsServiceClientDependencies {
  lambda: LambdaClient;
}

export class TrackingCredentialsServiceClient {
  constructor(
    private dependencies: TrackingCredentialsServiceClientDependencies,
  ) {}

  async getUserMapShareLink(input: WithUserId): Promise<UserMapShareLink> {
    const lambdaOutput = await this.dependencies.lambda.send(
      new InvokeCommand({
        FunctionName: AUTHORIZER_LAMBDA_FUNCTION_NAME,
        Payload: JSON.stringify(input satisfies WithUserId),
      }),
    );
    const authResult = String(lambdaOutput.Payload!);
    return JSON.parse(authResult);
  }
}
